import React, { useCallback, useEffect, useState } from 'react'

import {priceFormatter, phone} from '../../../helpers/Numbers'
import carResource from '../../../helpers/CarResource'
import { TagManager } from '../../../helpers/TagManager';
import imboxToggle from '../../../helpers/imboxToggle'
import breakPoints from '../../../helpers/breakPoints'

const BuyingOptions = ({car, order, setShouldShowEcomModal}) => {

    const hasSalePrice = car.oldPrice ? true:false;
    const isLeasable = car.leasingPrice ? true:false;
    let hasTriggeredEcom = false
    // let hasCarConversionTestDrive = false

    // const shareLink = (car) => {

    //     const url = window.location.href
    //     const to = ''
    //     const title = car.title + ' ' + car.shortDescription
    //     const body = `Jag vill tipsa dig om en bil på Bilbolaget: %0D%0A${title}%0D%0A${car.fuelType}, ${car.gearboxType}, ${car.modelYear}%0D%0A%0D%0A${url}`

    //     const urlParams = new URLSearchParams();
    //     urlParams.set('to', to)
    //     urlParams.set('subject', 'Tips ' + title)
    //     urlParams.set('body', body)
    //     return `mailto:?to=${to}&subject=Tips ${title}&body=${body}`;
    // }

    return (
        car &&
        <div>
                { hasSalePrice && <span className="block-text light strike">{priceFormatter(car.oldPrice,' kr')}</span> }
                <div className="price">
                    <span className={`block-text ${hasSalePrice ? 'passion' : 'grey'} large`}>{priceFormatter(car.price, ' kr')}</span>
                </div>
                { hasSalePrice && <span className="block-text black">Prissänkt {priceFormatter( car.oldPrice - car.price, ' kr' )}</span>}
                { isLeasable && <div className="leasing-price my-1">Privatleasing från <strong>{priceFormatter(car.leasingPrice,' kr/mån')}</strong></div>}

                <p className="disclaimer">
                    {/* 14 dagars öppet köp<br/> */}
                    Köp nu - betala vid leverans
                </p>

                { order && <MonthlyCost payment={order} />}
            <div className="buying-button-group">
                <div className="bb-button bb-btn-default align-wide mb-1 mr-0">
                    <a 
                        href='#kop-direkt' 
                        onClick={ (e) => { 
                            e.preventDefault(); 
                            if(!hasTriggeredEcom) {
                                // Trigger event, once
                                TagManager({event:'EcomInitialized'})
                                hasTriggeredEcom = true
                            }
                            setShouldShowEcomModal(true);
                            if(breakPoints.max('sm')) {
                                imboxToggle().off()
                            }
                        }}
                    >
                        Köp direkt
                    </a>
                </div>
                <div className="bb-button bb-btn-outline align-wide mb-1 mr-0">
                    <a 
                        href={`tel:${car.branch.phone}`}>
                        Ring { phone(car.branch.phone) }
                    </a>
                </div>  
                <div className="bb-button bb-btn-outline align-wide mb-1 mr-0">
                    <a 
                        href='#wpforms-section'>
                        Bli kontaktad
                    </a>
                </div>  
                <div className="bb-button bb-btn-outline align-wide mb-1 text-black mr-0">
                    <a 
                        href='#wpforms-section'>
                        Boka provkörning
                    </a>
                </div>

                <div className="share-like">
                    <div className="bb-button bb-btn-no-content align-wide mr-0">
                        <SaveCar car={car} />
                    </div>
                    {/* <div className="bb-button bb-btn-no-content align-wide mr-0">
                        <a href={shareLink(car)} className="share">
                            Dela
                        </a>
                    </div> */}
                </div>
            </div>
        </div>
    )
}


const MonthlyCost = ({payment}) => {

	// const pricePerMonth = payment.filter( p => p.type === 'Loan' )[0];
	return (
		<div className="monthly-cost">

            <div className="payment-information">
                <div className="payment-details">
                    <h3 className="price">
                        {priceFormatter(payment.monthlyCost, ' kr/mån') } 
                    </h3>
                    <p className="mb-0">
                        <span>Delbetala {priceFormatter(payment.loanAmount, ' kr')} i {payment.duration.current} månader.</span>&thinsp;
                        { payment.downPayment !==null && 
                            <span>
                                Kontantinsats {priceFormatter(payment.downPayment.current)}
                                &thinsp;
                            </span>
                        }
                        <br />
                        <small className="conditions">* Beräknat på {(payment.interest * 100).toFixed(2)}%  - <a href="#lan">Läs mer</a></small>
                    </p>
                </div>
                <div className="payment-logo">
                    <img src={payment.imageUrl} alt={payment.financialInstitution} />
                </div>
            </div>
		</div>
	)
}

const SaveCar = ({car}) => {

    const [isSaved, setIsSaved ] = useState(false) 

    const save = useCallback(()=>{
        if(window.user) {
            const isSavedNew = window.user.favoritesList.includes(car.waykeId);
            isSavedNew 
                ? window.user.remove(carResource(car))
                : window.user.add(carResource(car))
            setIsSaved(!isSavedNew)
            // Was not saved, callback did save
            if(!isSavedNew) {
                TagManager({event: 'CarSavedConversion'})
            }
        }
    },[car])

    useEffect(()=>{
        let interval;
		const checkUser = () => {
			if( window.user === undefined ) {
				return
			}
			setIsSaved(window.user.favoritesList.includes(car.waykeId))
			clearInterval(interval)
		}
		interval = setInterval(checkUser, 50)
    },[car])

    return (
        <>
        { isSaved 
            ?
            <a 
                className="saved"
                href='#spara-bilen'
                onClick={save}
                >
                Sparad
            </a>
            :
            <a 
                className="save"
                href='#spara-bilen'
                onClick={save}
                >
                Spara bil
            </a>
        }
        </>
    )

}


export default BuyingOptions
